import {
  DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_BEGIN,
  DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_SUCCESS,
  DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_FAILURE,
  DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function appwriteUpdateExternalDatabase(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_BEGIN,
    });
    const {
      projectId,
      version,
      externalDbUuid,
      result,
      collectionId,
      collectionTitle,
      selectedPrimaryKey,
    } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/appwrites/${externalDbUuid}`,
        { fields: result, collectionId: collectionId, collectionTitle, selectedPrimaryKey },
        header,
      );

      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissappwriteUpdateExternalDatabaseError() {
  return {
    type: DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_BEGIN:
      return {
        ...state,
        appwriteUpdateExternalDatabasePending: true,
        appwriteUpdateExternalDatabaseError: null,
      };

    case DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_SUCCESS:
      return {
        ...state,
        appwriteUpdateExternalDatabasePending: false,
        appwriteUpdateExternalDatabaseError: null,
      };

    case DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_FAILURE:
      return {
        ...state,
        appwriteUpdateExternalDatabasePending: false,
        appwriteUpdateExternalDatabaseError: action.data.error,
      };

    case DATA_CONNECTOR_APPWRITEUPDATE_EXTERNAL_DATABASE_DISMISS_ERROR:
      return {
        ...state,
        appwriteUpdateExternalDatabaseError: null,
      };

    default:
      return state;
  }
}
